export function areEqualValues<Value = unknown>(a: Value, b: Value) {
  if (typeof b === 'object' && !Array.isArray(b) && b !== null) {
    return a === b
  }

  // The value could be a number, the DOM will stringify it anyway.
  return String(a) === String(b)
}
